/* eslint-disable */
<template>
  <div class="specialist-menu sub-menu">
    <ul>
      <li><router-link to="/search-specialist">Search Availability</router-link></li>
      <li class="is-icon" @click="getUrl">Download Referral Network</li>
    </ul>
    <ExportSpecialistModal ref="exportSpecialistsModal" />
  </div>
</template>

<script>


import utilities from '@/assets/js/utilities'
import ExportSpecialistModal from '@/components/ExportSpecialistModal'

export default {
  name: 'SpecialistMenu',
  components: {
    ExportSpecialistModal,
  },
  props: ["indexProps"],
  data() {
    return {
    }
  },
  methods: {
    async getUrl(){
      this.$store.dispatch("loading/setLoadComponent", true)
      var blob = await utilities.getSpecialistProfiles()
      this.$store.dispatch("loading/setLoadComponent", false)
      if (blob) {
        var a = document.createElement('a')
        a.setAttribute('href', blob)
        // a.setAttribute('target', '_blank')
        a.setAttribute('download', 'Red Health Referral Network.pdf')
        a.click()
        URL.revokeObjectURL(blob);
        document.body.removeChild(a);
      }

    }
  },
  beforeMount() {
    if(this.indexProps == undefined) {
      this.indexProps = 0
    }
  },
  mounted() {
    $(".sub-menu li").eq(this.indexProps).addClass("sub-menu-selected")
  },
}
</script>
